import { Directive, inject, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: 'form[formGroup][formDisabled]',
  standalone: false
})
export class FormDisabledDirective {
  private host = inject(FormGroupDirective);

  @Input() set formDisabled(isDisabled: boolean) {
    isDisabled
      ? this.host.form.disable({ emitEvent: false })
      : this.host.form.enable({ emitEvent: false });
  }
}
